/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_QUEUES = '[Encoding] Get Queues',
  GET_QUEUES_SUCCESS = '[Encoding] Get Queues Success',
  GET_QUEUES_FAILED = '[Encoding] Get Queues Failed',

  GET_DEMOGRAPHICS = '[Encoding] Get Demographics',
  GET_DEMOGRAPHICS_SUCCESS = '[Encoding] Get Demographics Success',
  GET_DEMOGRAPHICS_FAILED = '[Encoding] Get Demographics Failed',

  GET_OTHER_OPTIONS = '[Encoding] Get Other Options',
  GET_OTHER_OPTIONS_SUCCESS = '[Encoding] Get Other Options Success',
  GET_OTHER_OPTIONS_FAILED = '[Encoding] Get Other Options Failed',

  GET_EDUCATION_OPTIONS = '[Encoding] Get Education Options',
  GET_EDUCATION_OPTIONS_SUCCESS = '[Encoding] Get Education Success',
  GET_EDUCATION_OPTIONS_FAILED = '[Encoding] Get Education Failed',

  GET_OCCUPATION_OPTIONS = '[Encoding] Get Occupation Options',
  GET_OCCUPATION_OPTIONS_SUCCESS = '[Encoding] Get Occupation Success',
  GET_OCCUPATION_OPTIONS_FAILED = '[Encoding] Get Occupation Failed',

  CHECK_DUPLICATE_ENTRY = '[Encoding] Check Duplicate Entry',
  CHECK_DUPLICATE_ENTRY_SUCCESS = '[Encoding] Check Duplicate Entry Success',
  CHECK_DUPLICATE_ENTRY_FAILED = '[Encoding] Check Duplicate Entry Failed',

  ENCODE_APPLICATION_ENTRY = '[Encoding] Encode Application Entry',
  ENCODE_APPLICATION_ENTRY_SUCCESS = '[Encoding] Encode Application Entry Success',
  ENCODE_APPLICATION_ENTRY_FAILED = '[Encoding] Encode Application Entry Failed',

  UPDATE_APPLICATION_ENTRY = '[Encoding] Update Application Entry',
  UPDATE_APPLICATION_ENTRY_SUCCESS = '[Encoding] Update Application Entry Success',
  UPDATE_APPLICATION_ENTRY_FAILED = '[Encoding] Update Application Entry Failed',

  GET_DOCUMENT_OPTIONS = '[Encoding] Get Documents Options',
  GET_DOCUMENT_OPTIONS_SUCCESS = '[Encoding] Get Documents Success',
  GET_DOCUMENT_OPTIONS_FAILED = '[Encoding] Get Documents Failed',
}

export const getQueues = createAction(
  ActionTypes.GET_QUEUES,
  props<{ data: any }>()
);

export const getQueuesSuccess = createAction(
  ActionTypes.GET_QUEUES_SUCCESS,
  props<{ data: any }>()
);

export const getQueuesFailed = createAction(
  ActionTypes.GET_QUEUES_FAILED,
  props<{ data: any }>()
);

export const getDemographics = createAction(
  ActionTypes.GET_DEMOGRAPHICS
);

export const getDemographicsSuccess = createAction(
  ActionTypes.GET_DEMOGRAPHICS_SUCCESS,
  props<{ data: any }>()
);

export const getDemographicsFailed = createAction(
  ActionTypes.GET_DEMOGRAPHICS_FAILED,
  props<{ data: any }>()
);

export const getOtherOptions = createAction(
  ActionTypes.GET_OTHER_OPTIONS
);

export const getOtherOptionsSuccess = createAction(
  ActionTypes.GET_OTHER_OPTIONS_SUCCESS,
  props<{ data: any }>()
);

export const getOtherOptionsFailed = createAction(
  ActionTypes.GET_OTHER_OPTIONS_FAILED,
  props<{ data: any }>()
);

export const getEducationOptions = createAction(
  ActionTypes.GET_EDUCATION_OPTIONS
);

export const getEducationOptionsSuccess = createAction(
  ActionTypes.GET_EDUCATION_OPTIONS_SUCCESS,
  props<{ data: any }>()
);

export const getEducationOptionsFailed = createAction(
  ActionTypes.GET_EDUCATION_OPTIONS_FAILED,
  props<{ data: any }>()
);

export const getOccupationOptions = createAction(
  ActionTypes.GET_OCCUPATION_OPTIONS
);

export const getOccupationOptionsSuccess = createAction(
  ActionTypes.GET_OCCUPATION_OPTIONS_SUCCESS,
  props<{ data: any }>()
);

export const getOccupationOptionsFailed = createAction(
  ActionTypes.GET_OCCUPATION_OPTIONS_FAILED,
  props<{ data: any }>()
);

export const checkDuplicateEntry = createAction(
  ActionTypes.CHECK_DUPLICATE_ENTRY,
  props<{ data: any }>()
);

export const checkDuplicateEntrySuccess = createAction(
  ActionTypes.CHECK_DUPLICATE_ENTRY_SUCCESS,
  props<{ data: any }>()
);

export const checkDuplicateEntryFailed = createAction(
  ActionTypes.CHECK_DUPLICATE_ENTRY_FAILED,
  props<{ data: any }>()
);

export const encodeApplicationEntry = createAction(
  ActionTypes.ENCODE_APPLICATION_ENTRY,
  props<{ data: any }>()
);

export const encodeApplicationEntrySuccess = createAction(
  ActionTypes.ENCODE_APPLICATION_ENTRY_SUCCESS,
  props<{ data: any }>()
);

export const encodeApplicationEntryFailed = createAction(
  ActionTypes.ENCODE_APPLICATION_ENTRY_FAILED,
  props<{ data: any }>()
);

export const getDocumentOptions = createAction(
  ActionTypes.GET_DOCUMENT_OPTIONS
);

export const getDocumentOptionsSuccess = createAction(
  ActionTypes.GET_DOCUMENT_OPTIONS_SUCCESS,
  props<{ data: any }>()
);

export const getDocumentOptionsFailed = createAction(
  ActionTypes.GET_DOCUMENT_OPTIONS_FAILED,
  props<{ data: any }>()
);

export const updateApplicationEntry = createAction(
  ActionTypes.UPDATE_APPLICATION_ENTRY,
  props<{uuid: any, data: any }>()
);

export const updateApplicationEntrySuccess = createAction(
  ActionTypes.UPDATE_APPLICATION_ENTRY_SUCCESS,
  props<{ data: any }>()
);

export const updateApplicationEntryFailed = createAction(
  ActionTypes.UPDATE_APPLICATION_ENTRY_FAILED,
  props<{ data: any }>()
);